export enum StaticTablePath {
    Gender = "/reference/gender",
    Country = "/reference/country",
    Nationality = "/reference/nationality",
    Languages = "/reference/language",
    TaxStatus = "/reference/taxStatus",
    TaxStatusMoral = "/reference/taxStatus/moral",
    PersonTitle = "/reference/personTitle",
    LegalStatus = "/reference/legalStatus",
    RelationType = "/reference/relationType",
    MaritalStatus = "/reference/maritalStatus",
    SocialStatus = "/reference/socialStatuses",
    PhoneNumberType = "/reference/phoneNumberType",
    BankAccountType = "/reference/bankAccountType",
    DriverLicenseType = "/reference/driversLicenseType",
    AdditionalTaxStatus = "/reference/additionalTaxStatus",
    PersonTitleSchool = "/reference/personTitleSchoolClaim",
    BrokenGlasses = "/reference/brokenGlasses",
    Nature = "/reference/nature",
    DamageType = "/reference/damageType",
    Place = "/reference/place",
    EmailType = "/reference/emailType",
    ArchitectType = "/reference/architectType",
    WorkNature = "/reference/workNature",
    AddressType = "/reference/addressType",
    VehiclePowerType = "/reference/vehicle/powers",
    VehicleFuelType = "/reference/vehicle/fuels",
    VehicleDocuments = "/reference/vehicle/documents",
    VehicleUsages = "/reference/vehicle/usages",
    VehicleStatuses = "/reference/vehicle/statuses",
    VehicleType = "/reference/vehicle/types",
    VehicleClaimLiabilityResponsibility = "/reference/vehicle/claim/liability/responsibility",
    VehicleInsuranceCoverage = "/reference/vehicle/insurance/coverage",
    VehicleInsuranceProtection = "/reference/vehicle/insurance/protection",
    YesNo = "/fakeReference/yesNo",
}
